module.exports = __webpack_public_path__ + "static/media/map.a58ae9c8.svg";